import React, { Component } from "react"
import { ModalContainer, ModalDialog } from "react-modal-dialog"
import PrepostoForm from "./PrepostoForm"
import { HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
export default class PrepostoModal extends Component {
  constructor() {
    super()
    this.callBackPreposto = this.callBackPreposto.bind(this)
    this.state = { isShowingModal: false }
  }
  getUnidades() {
    ApiHelper.getPreposto(this.props.prepostoId, (item, error) => {
      if (item) {
        this.props.callBack(item)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }

  callBackPreposto() {
    this.getUnidades()
  }
  render() {
    if (this.state.httpError) {
      return (
        <div onClick={this.props.onClose}>
          {this.props.show && (
            <ModalContainer onClose={this.props.onClose}>
              <ModalDialog
                style={{ width: "70%" }}
                onClose={this.props.onClose}
              >
                <HttpError
                  message={this.state.httpError.message}
                  status={this.state.httpError.status}
                />
              </ModalDialog>
            </ModalContainer>
          )}
        </div>
      )
    }
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <PrepostoForm
                prepostoId={this.props.prepostoId}
                callBackPreposto={this.callBackPreposto}
              />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/PrepostoModal.js